module.exports = __webpack_public_path__ + "static/media/cof.d44bb99c.png";